import React from 'react';
import { useTheme } from '../core/ThemeProvider';
import useDevice from '../core/hooks/useDevice';

export const resizeIcon = Icon => {
  const { theme } = useTheme();
  const { isMobile } = useDevice();

  let size = theme.listItem.sizeThumbnailIcon;
  let stroke = 'none';

  if (Icon?.type?.name.includes('Arrow')) {
    if (isMobile) {
      size = theme.listItem.sizeArrowIconXS;
      stroke = theme.listItem.colorIcon;
    } else {
      size = theme.listItem.sizeArrowIcon;
    }
  }

  return <Icon size={size} color={theme.listItem.colorIcon} stroke={stroke} />;
};
